﻿import React from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import CalculadoraNr1Tab from './CalculadoraNr1Tab'
import CalculadoraParametrosTab from './CalculadoraParametrosTab'

type ActiveTab = 'nr1' | 'parametros'

const Calculadoras: React.FC = () => {
  const [moduleInfo, setModuleInfo] = React.useState<{
    display_name: string
    description?: string | null
  } | null>(null)
  const [activeTab, setActiveTab] = React.useState<ActiveTab>('nr1')

  React.useEffect(() => {
    const loadModule = async () => {
      const result = await modulesService.getByName('comercial_calculadoras')
      if (result.success && result.data) {
        setModuleInfo({
          display_name: result.data.display_name ?? 'Calculadoras',
          description: result.data.description ?? null,
        })
      }
    }
    void loadModule()
  }, [])

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
        <PermissionGuard moduleName="comercial_calculadoras" permissionType="show">
          <div className="h-full flex flex-col">
            <div className="p-6 border-b border-gray-200 dark:border-gray-700">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                {moduleInfo?.display_name ?? 'Calculadoras'}
              </Heading>
              {moduleInfo?.description && (
                <Text size="sm" color="muted" className="mt-1">
                  {moduleInfo.description}
                </Text>
              )}
            </div>

            <div className="px-6 pt-4 border-b border-gray-200 dark:border-gray-700">
              <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="-mb-px flex space-x-8">
                  <button
                    type="button"
                    onClick={() => setActiveTab('nr1')}
                    className={`py-3 px-1 border-b-2 font-medium text-sm ${
                      activeTab === 'nr1'
                        ? 'border-primary-600 text-primary-600 dark:text-primary-400'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
                    }`}
                  >
                    NR-1
                  </button>
                  <PermissionGuard
                    moduleName="comercial_calculadoras"
                    permissionType="update"
                    fallback={null}
                  >
                    <button
                      type="button"
                      onClick={() => setActiveTab('parametros')}
                      className={`py-3 px-1 border-b-2 font-medium text-sm ${
                        activeTab === 'parametros'
                          ? 'border-primary-600 text-primary-600 dark:text-primary-400'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
                      }`}
                    >
                      Parâmetros
                    </button>
                  </PermissionGuard>
                </nav>
              </div>
            </div>

            {activeTab === 'nr1' && <CalculadoraNr1Tab />}

            {activeTab === 'parametros' && (
              <PermissionGuard
                moduleName="comercial_calculadoras"
                permissionType="update"
                fallback={null}
              >
                <CalculadoraParametrosTab />
              </PermissionGuard>
            )}
          </div>
        </PermissionGuard>
    </div>
  )
}

export default Calculadoras
